import { Component, Input, OnInit } from '@angular/core';

import { Property, PropertySet } from '@mirage-projects/cw-models';

import { PropertyBagService } from '../property-bag.service';

/**
 * This component is used to display a bolean toggle field in the property bag
 */
@Component({
    selector: 'cw-property-toggle',
    templateUrl: './property-toggle.component.html',
    standalone: false,
})
export class PropertyToggleComponent implements OnInit {
    /** This object comes from the core and provides methods to obtain and set the value of the properties */
    @Input() propertySet!: PropertySet;

    /** Input field with the required information for this field type */
    @Input() property!: Property;

    propertyValue = false;
    label = '';

    constructor(private propertyBagService: PropertyBagService) {}

    ngOnInit(): void {
        this.label = this.propertyBagService.getCorrectLabel(this.property);
        this.propertyValue = this.propertyBagService.getValueProperty(this.propertySet, this.property);
    }

    onChange(checked: boolean): void {
        this.property.value = checked;
        this.propertyBagService.setValueProperty(this.propertySet, this.property);
    }
}
